import React, { FC } from 'react';
import { Box, Typography, Button, Skeleton } from '@mui/material';
import { NavLink } from 'react-router-dom';

interface ReferCardProps {
    open: boolean;
    loading?: boolean;
    backgroundImage: string;
    gif: string;
}

const ReferCard: FC<ReferCardProps> = ({
    open,
    loading = false,
    backgroundImage,
    gif,
}) => {
    if (!open && !loading) return null;

    return (
        <Box
            width={440}
            my={2.5}
            borderRadius="20px"
            padding="30px"
            sx={{
                background: loading
                    ? 'rgba(255,255,255,0.05)'
                    : `url(${backgroundImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
            }}
        >
            {/* TOP SECTION */}
            <Box
                display="flex"
                mb="20px"
                alignItems="center"
                justifyContent="space-between"
            >
                {loading ? (
                    <>
                        <Skeleton width={260} height={60} />
                        <Skeleton variant="circular" width={80} height={80} />
                    </>
                ) : (
                    <>
                        <Typography
                            fontSize="24px"
                            maxWidth="300px"
                            fontWeight="bold"
                            color="white"
                        >
                            Invite your friends and earn exclusive rewards!
                        </Typography>

                        <img
                            src={gif}
                            alt="Refer animation"
                            height="80"
                            width="80"
                        />
                    </>
                )}
            </Box>

            {/* BUTTON */}
            {loading ? (
                <Skeleton
                    variant="rounded"
                    height={50}
                    sx={{ borderRadius: '12px' }}
                />
            ) : (
                <NavLink to="/referfriend" style={{ textDecoration: 'none' }}>
                    <Button fullWidth className='btn btn-blue' sx={{ textWrap: 'nowrap', padding: '13px 128px', fontSize: '16px', fontWeight: 'bold', gap: '10px' }}>Refer & Win
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.0001 7.16C17.9401 7.15 17.8701 7.15 17.8101 7.16C16.4301 7.11 15.3301 5.98 15.3301 4.58C15.3301 3.15 16.4801 2 17.9101 2C19.3401 2 20.4901 3.16 20.4901 4.58C20.4801 5.98 19.3801 7.11 18.0001 7.16Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.9704 14.4402C18.3404 14.6702 19.8504 14.4302 20.9104 13.7202C22.3204 12.7802 22.3204 11.2402 20.9104 10.3002C19.8404 9.59016 18.3104 9.35016 16.9404 9.59016" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.97047 7.16C6.03047 7.15 6.10047 7.15 6.16047 7.16C7.54047 7.11 8.64047 5.98 8.64047 4.58C8.64047 3.15 7.49047 2 6.06047 2C4.63047 2 3.48047 3.16 3.48047 4.58C3.49047 5.98 4.59047 7.11 5.97047 7.16Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.00043 14.4402C5.63043 14.6702 4.12043 14.4302 3.06043 13.7202C1.65043 12.7802 1.65043 11.2402 3.06043 10.3002C4.13043 9.59016 5.66043 9.35016 7.03043 9.59016" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.0001 14.6302C11.9401 14.6202 11.8701 14.6202 11.8101 14.6302C10.4301 14.5802 9.33008 13.4502 9.33008 12.0502C9.33008 10.6202 10.4801 9.47021 11.9101 9.47021C13.3401 9.47021 14.4901 10.6302 14.4901 12.0502C14.4801 13.4502 13.3801 14.5902 12.0001 14.6302Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.08973 17.7804C7.67973 18.7204 7.67973 20.2603 9.08973 21.2003C10.6897 22.2703 13.3097 22.2703 14.9097 21.2003C16.3197 20.2603 16.3197 18.7204 14.9097 17.7804C13.3197 16.7204 10.6897 16.7204 9.08973 17.7804Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </Button>
                </NavLink>
            )}
        </Box>
    );
};

export default React.memo(ReferCard);
